import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
export function PricingPreview() {
  return <div className="py-24 bg-gate-dark" data-id="element-203">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
        <div className="text-center mb-16" data-id="element-205">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-206">
            Hardware Comparison
          </h2>
          <p className="text-gate-text-secondary max-w-2xl mx-auto" data-id="element-207">
            See why FPGAs are the superior choice for inference workloads.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-208">
          {/* CPU Card */}
          <div className="p-8 rounded-2xl bg-gate-surface border border-gate-border opacity-70 hover:opacity-100 transition-opacity" data-id="element-209">
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-210">CPU Inference</h3>
            <p className="text-sm text-gate-text-muted mb-6" data-id="element-211">
              Standard x86/ARM Processors
            </p>
            <div className="space-y-4 mb-8" data-id="element-212">
              <div className="flex justify-between border-b border-gate-border pb-2" data-id="element-213">
                <span className="text-gate-text-secondary" data-id="element-214">Latency</span>
                <span className="text-white font-mono" data-id="element-215">15-50ms</span>
              </div>
              <div className="flex justify-between border-b border-gate-border pb-2" data-id="element-216">
                <span className="text-gate-text-secondary" data-id="element-217">Throughput</span>
                <span className="text-white font-mono" data-id="element-218">Low</span>
              </div>
              <div className="flex justify-between border-b border-gate-border pb-2" data-id="element-219">
                <span className="text-gate-text-secondary" data-id="element-220">Power</span>
                <span className="text-white font-mono" data-id="element-221">100W+</span>
              </div>
              <div className="flex justify-between border-b border-gate-border pb-2" data-id="element-222">
                <span className="text-gate-text-secondary" data-id="element-223">Cost / 1M</span>
                <span className="text-white font-mono" data-id="element-224">$0.50+</span>
              </div>
            </div>
          </div>

          {/* FPGA Card (Highlighted) */}
          <div className="relative p-8 rounded-2xl bg-gate-surface border-2 border-gate-teal shadow-[0_0_40px_-10px_rgba(0,212,170,0.2)] transform md:-translate-y-4" data-id="element-225">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gate-teal text-gate-dark px-4 py-1 rounded-full text-sm font-bold shadow-lg" data-id="element-226">
              Recommended
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-227">
              FPGA Inference
            </h3>
            <p className="text-sm text-gate-text-muted mb-6" data-id="element-228">
              OpenFPGA Optimized Hardware
            </p>
            <div className="space-y-4 mb-8" data-id="element-229">
              <div className="flex justify-between border-b border-gate-border pb-2" data-id="element-230">
                <span className="text-gate-text-secondary" data-id="element-231">Latency</span>
                <span className="text-gate-teal font-bold font-mono" data-id="element-232">
                  {'<'}1ms
                </span>
              </div>
              <div className="flex justify-between border-b border-gate-border pb-2" data-id="element-233">
                <span className="text-gate-text-secondary" data-id="element-234">Throughput</span>
                <span className="text-gate-teal font-bold font-mono" data-id="element-235">High</span>
              </div>
              <div className="flex justify-between border-b border-gate-border pb-2" data-id="element-236">
                <span className="text-gate-text-secondary" data-id="element-237">Power</span>
                <span className="text-gate-teal font-bold font-mono" data-id="element-238">
                  10-30W
                </span>
              </div>
              <div className="flex justify-between border-b border-gate-border pb-2" data-id="element-239">
                <span className="text-gate-text-secondary" data-id="element-240">Cost / 1M</span>
                <span className="text-gate-teal font-bold font-mono" data-id="element-241">
                  $0.02+
                </span>
              </div>
            </div>
            <ul className="space-y-3 mb-8" data-id="element-242">
              <li className="flex items-center text-sm text-white" data-id="element-243">
                <Check className="w-4 h-4 text-gate-teal mr-2" data-id="element-244" />
                Deterministic Timing
              </li>
              <li className="flex items-center text-sm text-white" data-id="element-245">
                <Check className="w-4 h-4 text-gate-teal mr-2" data-id="element-246" />
                Bitstream Hot-Swapping
              </li>
              <li className="flex items-center text-sm text-white" data-id="element-247">
                <Check className="w-4 h-4 text-gate-teal mr-2" data-id="element-248" />
                Custom Logic Support
              </li>
            </ul>
            <button className="w-full py-3 rounded-lg bg-gate-teal text-gate-dark font-bold hover:bg-gate-teal/90 transition-colors" data-id="element-249">
              Start Building
            </button>
          </div>

          {/* GPU Card */}
          <div className="p-8 rounded-2xl bg-gate-surface border border-gate-border opacity-70 hover:opacity-100 transition-opacity" data-id="element-250">
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-251">GPU Inference</h3>
            <p className="text-sm text-gate-text-muted mb-6" data-id="element-252">
              Standard H100/A100 Clusters
            </p>
            <div className="space-y-4 mb-8" data-id="element-253">
              <div className="flex justify-between border-b border-gate-border pb-2" data-id="element-254">
                <span className="text-gate-text-secondary" data-id="element-255">Latency</span>
                <span className="text-white font-mono" data-id="element-256">10-100ms</span>
              </div>
              <div className="flex justify-between border-b border-gate-border pb-2" data-id="element-257">
                <span className="text-gate-text-secondary" data-id="element-258">Throughput</span>
                <span className="text-white font-mono" data-id="element-259">Very High</span>
              </div>
              <div className="flex justify-between border-b border-gate-border pb-2" data-id="element-260">
                <span className="text-gate-text-secondary" data-id="element-261">Power</span>
                <span className="text-white font-mono" data-id="element-262">300W+</span>
              </div>
              <div className="flex justify-between border-b border-gate-border pb-2" data-id="element-263">
                <span className="text-gate-text-secondary" data-id="element-264">Cost / 1M</span>
                <span className="text-white font-mono" data-id="element-265">$0.10+</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-266">
          <a href="#" className="inline-flex items-center text-gate-teal hover:text-gate-teal/80 font-medium transition-colors" data-id="element-267">
            View Full Pricing <ArrowRight className="ml-2 w-4 h-4" data-id="element-268" />
          </a>
        </div>
      </div>
    </div>;
}